import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GradeList, GradingRule, GradingRuleList} from './interface/grading-rule.interface';
import {Observable} from 'rxjs/Observable';
import {GradeRule} from "./enum/grade-rule";

@Injectable()
export class GradingRuleService {
    constructor(private http: HttpClient) {
    }

    currentValidGradeList: Array<GradingRule>;

    get(): Observable<GradingRuleList> {
        return this.http.get<GradingRuleList>('/api/gradingRule');
    }

    setCurrentGradingList(gradingRuleList: Array<GradingRule>) {
        this.currentValidGradeList = gradingRuleList;
    }

    getValidGradingList(gradeLevel: string, gradeMode: string) {

        return this.currentValidGradeList?.filter(
            (item: GradingRule) =>
                item.gradeLevel === gradeLevel &&
                item.gradeMode === gradeMode
        );
    }

    isValidGrade(gradeLevel: string, gradeMode: string, grade: string) {
        const getValidGradeList = this.getValidGradingList(gradeLevel, gradeMode);
        return getValidGradeList.find((item: GradingRule) => item.validGrade === grade);
    }

    getGradeListGD(): Observable<Array<GradeList>> {
        return this.http.get<Array<GradeList>>('/gradingRule/gradeListGD');
    }

    getGradeListI(): Observable<Array<GradeList>> {
        return this.http.get<Array<GradeList>>('/gradingRule/gradeListI');
    }

    getGradeListIP(): Observable<Array<GradeList>> {
        return this.http.get<Array<GradeList>>('/gradingRule/gradeListIP');
    }


}
